import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { NotFoundComponent } from './not-found/not-found.component';
import { AuthGuard } from './core/guards/auth.guard';
import { ContentComponent } from './content/content.component';
import { APP_BASE_HREF } from '@angular/common';

export const routes: Routes = [
    { path: 'error', loadChildren: () => import("./error/error.module").then((m)=> m.ErrorModule) },
    {   path: '',
        component: AppComponent,
        runGuardsAndResolvers: "always",
        canActivate: [AuthGuard],
        data: { reuse: false }
    },
    { path: 'home', component: ContentComponent,  data: { reuse: false }   },
    { path: '**', component: NotFoundComponent,  data: { reuse: false }   },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            useHash: true,
            paramsInheritanceStrategy: 'always'
        })
    ],
    providers: [{ provide: APP_BASE_HREF, useValue: '' }],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
